import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { EconomyService, PriceListItem } from '../../../services/economy.service';

@Component({
    selector: 'tt-interbranch-level',
    templateUrl: './interbranch-level.component.html',
    styleUrls: ['./interbranch-level.component.css'],
})
export class InterbranchLevelComponent implements OnInit {
    interBranchLevelKeyno;

    public edit?: Edit;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListPrices: PriceListItem[] = [];

    public saving = false;

    constructor(
        private stateService: StateService,
        private datatask: DataTaskService,
        private logistic: LogisticService,
        private economy: EconomyService,
    ) {
        this.interBranchLevelKeyno = this.stateService.getStateParams()['interbranchlevel_keyno'];
    }

    private async loadEdit() {
        if (!!this.interBranchLevelKeyno) {
            this.edit = (await this.datatask.Post(792, { interbranchlevel_keyno: this.interBranchLevelKeyno }))[0];
        }
    }

    private async loadCompanies(): Promise<void> {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadPrices(): Promise<void> {
        this.selectListPrices = await this.economy.getPriceLists();
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(793, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadCompanies();
        this.loadPrices();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    interbranchlevel_keyno: number;
    interbranchmulti_keyno: number;
    level_no: number;
    businessco_no: number;
    pricelist_id: string;
    discount_pst: string;
    businessco_no_to: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('interBranchLevel', {
//        templateUrl: 'views/components/views/interBranchLevel/interBranchLevel.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'interBranchLevelService', 'logisticService', 'economyService', function ($stateParams, stateService, interBranchLevelService, logisticService, economyService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let interBranchLevelKeyno = $stateParams.interbranchlevel_keyno;

//            vm.model = {
//                edit: {},
//                selectListCompanies: [],
//                selectListPrices: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await interBranchLevelService.getEdit({ interbranchlevel_keyno: interBranchLevelKeyno }))[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadPrices() {
//                vm.model.selectListPrices = await economyService.listPrices();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                interBranchLevelService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//                loadCompanies();
//                loadPrices();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
